
const it = {
    color: {
        label: 'Colore',
        list: 'Elenco Colori',
        listTitle: 'Colori Pantone: {pantoneName}',
        mutateSubtitle: 'Modifica Colore',
        name: 'Nome Colore',
        code: 'Codice',
        image: 'Immagine',
        connectPantone: 'Collega Pantone',
        selectColor: 'Seleziona Colore',
        other: 'Altro',
        price: 'Prezzo',
        colorName: 'Colore Personalizzato',
        picker: {
            label: 'Seleziona Colore',
            hexValue: 'Valore Hex',
            rgbValue: 'Valore RGB',
            hslValue: 'Valore HSL',
        }

    },
    pantone: {
        list: 'Elenco Pantoni',
        mutateSubtitle: 'Modifica Pantone',
        name: 'Nome Pantone',
        code: 'Codice',
        price: 'Prezzo',
        shortDescription: 'Descrizione Breve',
        description: 'Descrizione',
        thumbnail: 'Miniatura',
        connectColor: 'Collega Colore',
        connectProductModel: 'Collega Modello Prodotto',
        otherSelector: 'Altro non a catalogo',

        materialType: {
            label: 'Tipo di Materiale',
            PVC: 'PVC',
            WOOD: 'Legno',
            ALUMINIUM: 'Alluminio',
        },
        tabName: {
            PANTONE: 'Pantoni',
            COLOR: 'Colori',
        },
        selectPantone: 'Seleziona Pantone',
    },
    pantoneColor: {
        title: 'Associazione Pantone Colore ',
        subtitleBoth: 'Colore: {colorName} - Pantone: {pantoneName}',
        subtitleColor: 'Colore: {colorName}',
        subtitlePantone: 'Pantone: {pantoneName}',
    },
    pantoneProductModel: {
        title: 'Associazione Pantone Modello Prodotto',
        subtitleBoth: 'Modello Prodotto: {productModelName} - Pantone: {pantoneName}',
        subtitleProductModel: 'Modello Prodotto: {productModelName}',
        subtitlePantone: 'Pantone: {pantoneName}',
    }
}
export default it